const DepositsAndWithdrawalsContentTwo = () => {
  const securityFeatures = [
    {
      title: "Licensed Across Multiple Jurisdictions",
      text: "We follow strict international regulatory requirements, ensuring every process from onboarding to withdrawals meets global compliance standards.",
    },
    {
      title: "Advanced AML & KYC Frameworks",
      text: "Your identity and transactions are rigorously verified to prevent fraud, protect your funds, and maintain a secure trading environment.",
    },
    {
      title: "Secure Transaction Monitoring",
      text: "Every deposit and withdrawal undergoes automated and manual checks, ensuring accuracy, transparency, and full protection against suspicious activity.",
    },
    {
      title: "Data Encryption & Account Safety",
      text: "Your personal information and financial data are secured through bank-grade encryption, safeguarding your account from unauthorized access at all times.",
    },
  ];

  return (
    <div className="sm-security-section">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE: Main Heading */}
          <div className="col-lg-4 col-md-12 col-12">
            <div className="sm-content-left">
              <h2 className="sm-main-title">
                Regulated. Transparent. <br /> Built for Protection
              </h2>
            </div>
          </div>

          {/* RIGHT SIDE: Intro Text + Feature List */}
          <div className="col-lg-8 col-md-12 col-12">
            <div className="sm-content-right">
              <p className="sm-intro-text">
                Your funds are safeguarded by strict global standards and
                industry-leading security practices. We operate under robust
                regulatory frameworks, apply advanced compliance protocols, and
                ensure every transaction is processed with integrity and
                oversight.
              </p>

              <div className="sm-feature-list">
                {securityFeatures.map((item, index) => (
                  <div key={index} className="sm-feature-item">
                    <div className="sm-feature-row">
                      <div className="sm-feature-title">
                        <h3>{item.title}</h3>
                      </div>
                      <div className="sm-feature-desc">
                        <p>{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepositsAndWithdrawalsContentTwo;
